export default __webpack_public_path__ + "static/media/WindDirection.73b36652.png";